export default "/credits/business/assets/fff4a7c1d808f89afc0fda5f0beb970d.png";